const initialState = {
    solutions: null,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case "SET_SOLUTIONS":
        return {
          ...state,
          solutions: action.payload,
        };
      default:
        return state;
    }
  };
  